module.exports = __webpack_public_path__ + "static/media/q5.64efb751.svg";